// An admin table (APS-412, admin-d.md "Tables"): Console D's `.t` in a region that scrolls
// sideways, with a minimum width so its columns never crush, and, under 760 px, the first
// column (the row's name) sticky at the left edge behind a 1 px rule. No fade: brand.md has no
// gradients.
import type { CSSProperties, ReactNode } from 'react'

export function DataTable({
  label,
  minWidth,
  className,
  children,
}: {
  /** What the table lists, for the scroll region's name. */
  label: string
  /** The width under which the region scrolls instead of squeezing the columns, in px. */
  minWidth: number
  className?: string | undefined
  children: ReactNode
}) {
  return (
    // biome-ignore lint/a11y/noNoninteractiveTabindex: a scrollable region must be focusable
    <section className="scroll-x" aria-label={label} tabIndex={0}>
      <table
        className={className ? `t sticky1 ${className}` : 't sticky1'}
        style={{ '--t-min': `${minWidth}px` } as CSSProperties}
      >
        {children}
      </table>
    </section>
  )
}
